<script setup>
// Component Imports
import Header from '@/components/mwi/Header.vue'
import Footer from '@/components/mwi/Footer.vue'
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <Header />
    <main class="flex-grow inline-grid">
      <slot/>
    </main>
    <Footer />
  </div>
</template>
